const TOAST_DURATION = 3000;
const TOAST_CLASSES = {
  error: "toast-message-error",
  success: "toast-message-success",
  warning: "toast-message-warning",
  info: "toast-message-info",
};

/**
 * Display a toast notification
 * @param {string} message - Message to display
 * @param {('error'|'success'|'warning'|'info')} type - Toast type
 * @param {number} duration - Duration in milliseconds
 */
export function displayToast(message, type = "error", duration = TOAST_DURATION) {
  // Prevent duplicate toasts with same message
  const existingToasts = document.querySelectorAll('[class^="toast-message"]');
  for (const toast of existingToasts) {
    if (toast.textContent === message) return;
  }

  const toastElement = document.createElement("div");
  toastElement.textContent = message;
  toastElement.className = TOAST_CLASSES[type] || TOAST_CLASSES.error;
  toastElement.setAttribute("role", "alert");
  toastElement.setAttribute("aria-live", "polite");
  
  document.body.appendChild(toastElement);

  // Trigger reflow for animation
  void toastElement.offsetHeight;
  toastElement.classList.add("toast-visible");

  setTimeout(() => {
    toastElement.classList.remove("toast-visible");
    toastElement.classList.add("toast-hidden");
    
    setTimeout(() => {
      if (toastElement.parentNode) {
        document.body.removeChild(toastElement);
      }
    }, 300); // Match CSS transition duration
  }, duration);
}
